import useStorage from "./useStorage";

const useLocalStorage = (key, initialValue) => {
    return useStorage(key, initialValue, window.localStorage);
}

export default useLocalStorage;